import './platform.messages';

export default (translator) => (key, args) => translator({ id: key }, args);
export { default as messages } from './platform.messages';
